<template>
  <section class="main">
        <router-view :key="key" />
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>
<style>
.main{
  width: 100%;
  padding: 0 calc((100% - 1200px) / 2);
  box-sizing: border-box;
  margin:61px auto 0;
  height: calc(100% - 113px);
}

@media screen and (max-width: 500px) {
    .main{
      width:100%;
      overflow:hidden;
      padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue